import { useQuery } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevineGroupApi } from '@/features/api/hooks/grapevine-group/useGrapevineGroupApi';
import { useAuth } from '@/features/authorization/provider/useAuth';

export const useGetPendingMembers = (groupId: string, count = 50) => {
  const { isAuthenticated } = useAuth();
  const api = useGrapevineGroupApi();

  return useQuery({
    queryKey: [API_CACHE_KEYS.PENDING_MEMBERS, groupId, count],
    queryFn: () => api.getPendingMembersByGroupId({ groupId, count }),
    enabled: isAuthenticated
  });
};
